<template>
    <div class="border rounded bg-white p-3">
        <h5 class="mb-2">Select Payment Type</h5> 
        <div class="form-check">
            <div v-if="$parent.AcceptCC && $root.square.accept_cc">
                <input v-model="payment_type" class="form-check-input" type="radio" id="payment-type-cc" value="cc">
                <label class="form-check-label" for="payment-type-cc">Credit Card<i class="far fa-credit-card ms-2"></i></label>
            </div>
        
            <div v-if="$parent.event.CheckPayment" >
                <input v-model="payment_type" class="form-check-input" type="radio" id="payment-type-pc" value="check">
                <label class="form-check-label" for="payment-type-pc">Check or Money Order<i class="fas fa-money-check ms-2"></i></label>
            </div>

            <div v-if="$parent.event.POPayment">
                <input v-model="payment_type" class="form-check-input" type="radio" id="payment-type-po" value="po">
                <label class="form-check-label" for="payment-type-po">Purchase Order<i class="fab fa-wpforms ms-2"></i></label>
            </div>

            <div v-if="$parent.event._AgencyAgreement.HasCode">
                <input v-model="payment_type" class="form-check-input" type="radio" id="payment-type-aa" value="aa">
                <label class="form-check-label" for="payment-type-aa">PD Consortium<i class="fas fa-school ms-2"></i></label>
            </div>
        </div>


        <!-- <ul class="list-group pe-pointer" id="payment-type-select" role="tablist">
            <li v-if="$parent.AcceptCC" 
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-start" 
                :class="payment_type == 'cc' ? 'active' : ''"
                @click="payment_type = 'cc'" 
                data-bs-toggle="list" 
                role="tab">

                <input name="pay_type_cc" class="visually-hidden" id="pay-type-cc" type="radio" value="cc" v-model="payment_type"/>
                <div class="me-auto">
                    <div class="fw-bold">Credit Card</div>
                </div>
                <div>
                    <i class="far fa-credit-card"></i>
                </div>
            </li>

            <li v-if="$parent.event.CheckPayment" 
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-start" 
                :class="payment_type == 'check' ? 'active' : ''"
                data-bs-toggle="list"
                @click="payment_type = 'check'"
                role="tab" >

                <input name="pay_type_check" class="visually-hidden" id="pay-type-check" type="radio" value="check" v-model="payment_type"/>
                <div class="me-auto">
                    <div class="fw-bold">Check / Money Order</div>
                </div>
                <div>
                    <i class="fas fa-money-check"></i>
                </div>
            </li>

            <li v-if="$parent.event.POPayment" 
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-start" 
                :class="payment_type == 'po' ? 'active' : ''"
                data-bs-toggle="list"
                @click="payment_type = 'po'"
                role="tab">

                <input name="pay_type_po" class="visually-hidden" id="pay-type-po" type="radio" value="po" v-model="payment_type"/>
                <div class="me-auto">
                    <div class="fw-bold">Purchase Order</div>
                </div>
                <div>
                    <i class="fab fa-wpforms"></i>
                </div>
            </li>

            <li v-if="$parent.event._AgencyAgreement.HasCode" 
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-start" 
                :class="payment_type == 'aa' ? 'active' : ''"
                data-bs-toggle="list"
                @click="payment_type = 'aa'"
                role="tab">

                <input name="pay_type_consortium" class="visually-hidden" id="pay-type-consortium" type="radio" value="aa" v-model="payment_type"/>
                <div class="me-auto">
                    <div class="fw-bold">PD Consortium</div>
                </div>
                <div>
                    <i class="fas fa-school"></i>
                </div>
            </li>

        </ul> -->
    </div>
</template>

<script>
export default {
    props: {
        value: {
            required: true,
            default: null,
            validator: prop => typeof prop === 'string' || prop === null
        }
    },

    mounted() {
        if (this.payment_type === null) {
            const aa_code = ('_AgencyAgreement' in this.$parent.event) ? this.$parent.event._AgencyAgreement.HasCode : false;

            if (this.$parent.AcceptCC && this.$root.square.accept_cc) {
                this.payment_type = 'cc';
            } else if (this.$parent.event.CheckPayment) {
                this.payment_type = 'check';
            } else if (this.$parent.event.POPayment) {
                this.payment_type = 'po';
            } else if (aa_code) {
                this.payment_type = 'aa';
            }
        }
    },

    updated() {
        this.$emit('input', this.payment_type);
    },

    data() {
        return {
            payment_type: null,
        }
    }
}
</script>